/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "loading-label": [{
    "type": 0,
    "value": "Lädt"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var deDE = Object.assign(TranslationProviderComponent, {
  translations
});

export { deDE as d };
//# sourceMappingURL=de-DE-C3FlQB6O.js.map
